import { BackgroundCheckStatus } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge.js';
import { getBackgroundCheckStatusLabel } from '@/lib/coach-utils.js';

interface BackgroundCheckStatusBadgeListProps {
  statuses: BackgroundCheckStatus[] | undefined;
}

export function BackgroundCheckStatusBadgeList({ statuses }: BackgroundCheckStatusBadgeListProps) {
  if (!statuses || statuses.length === 0) {
    return <span className="text-muted-foreground">None</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {statuses.map((status) => (
        <Badge key={status} variant="outline">
          {getBackgroundCheckStatusLabel(status)}
        </Badge>
      ))}
    </div>
  );
}
